export default {
  TableHead: [
    [
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.round',
      },
      {
        displayName: 'round.datatable.createdate',
      },
      {
        displayName: 'round.datatable.game',
      },
      {
        displayName: 'round.datatable.bet',
      },
      {
        displayName: 'round.datatable.detail',
      },
      {
        displayName: 'round.datatable.selectround',
        type: true,
      },
    ],
    [
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.detail',
      },
      {
        displayName: 'round.datatable.tracking',
      },
      {
        displayName: 'round.datatable.axios',
      },
      {
        displayName: 'round.datatable.status',
      },
    ],
    [
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.roundid',
      },
      {
        displayName: 'round.datatable.game',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.agent',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.type',
      },
      {
        displayName: 'round.datatable.createdate',
      },
      {
        displayName: 'round.datatable.updatedate',
      },
      {
        displayName: 'round.datatable.balancebefore',
      },
      {
        displayName: 'round.datatable.balanceafter',
      },
      {
        displayName: 'round.datatable.balance',
      },
      {
        displayName: 'round.datatable.detail',
      },
    ],
    [
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.agent',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.type',
      },
      {
        displayName: 'round.datatable.balancebefore',
      },
      {
        displayName: 'round.datatable.balanceafter',
      },
      {
        displayName: 'round.datatable.balance',
      },
    ],
    [ // modalTracking
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.detail',
      },
      {
        displayName: 'round.datatable.tracking',
      },
      {
        displayName: 'round.datatable.round',
      },
      {
        displayName: 'round.datatable.axios',
      },
      {
        displayName: 'round.datatable.status',
      },
    ],
    [ // modalDetail
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.agent',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.type',
      },
      {
        displayName: 'round.datatable.balancebefore',
      },
      {
        displayName: 'round.datatable.balanceafter',
      },
      {
        displayName: 'round.datatable.balance',
      },
    ],
    [ // modalTrackingBet
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.type',
      },
      {
        displayName: 'round.datatable.game',
      },
      {
        displayName: 'round.datatable.rank',
      },
      {
        displayName: 'round.datatable.room',
      },
      {
        displayName: 'round.datatable.createdate',
      },
      {
        displayName: 'round.datatable.status',
      },
      {
        displayName: 'round.datatable.balance',
      },
    ],
    [ // modalRound
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.type',
      },
      {
        displayName: 'round.datatable.balancebefore',
      },
      {
        displayName: 'round.datatable.balanceafter',
      },
      {
        displayName: 'round.datatable.amount',
      },
      {
        displayName: 'round.datatable.detail',
      },
      {
        displayName: 'round.datatable.timestamp',
      },
    ],
    [ // modalAxios
      {
        displayName: 'round.datatable.no',
      },
      {
        displayName: 'round.datatable.username',
      },
      {
        displayName: 'round.datatable.source',
      },
      {
        displayName: 'round.datatable.axiosrequestbet',
      },
      {
        displayName: 'round.datatable.axiosresponsebet',
      },
    ],
  ],
};
